export const adminActionConstants = {
  GET_APPROVAL_REQUESTED_INSTRUCTORS: "GET_APPROVAL_REQUESTED_INSTRUCTORS",
  GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID: "GET_APPROVAL_REQUESTED_INSTRUCTOR_DATA_BY_ID"
};
